import { all, takeLatest } from 'redux-saga/effects'
import { AnyAction } from '@reduxjs/toolkit'
import { defaultFlow } from 'redux/config/saga/Common'
import { transitPassActions } from './transitPassActions'
import { transitPassReducers } from './transitPassSlice'
import TransitPassService from './transitPassService'
import { CreateEmployeeTransitPassPayload } from './transitPassTypes'
import { Action } from 'shared/Types/Actions'

export function* getEmployeeTransitPasses(action: AnyAction) {
  yield defaultFlow(
    action,
    TransitPassService.getEmployeeTransitPasses,
    transitPassReducers.getEmployeeTransitPassesSuccess
  )
}

export function* createEmployeeTransitPass(
  action: Action<CreateEmployeeTransitPassPayload>
) {
  yield defaultFlow(
    action,
    TransitPassService.createEmployeeTransitPass,
    transitPassReducers.createEmployeeTransitPassSuccess
  )
}

export function* watchTransitPass() {
  yield takeLatest(
    transitPassActions.getEmployeeTransitPasses.type,
    getEmployeeTransitPasses
  )
  yield takeLatest(
    transitPassActions.createEmployeeTransitPass.type,
    createEmployeeTransitPass
  )
}

export default function* transitPassSaga() {
  yield all([watchTransitPass()])
}
